import { useState, useEffect } from 'react';

interface FooterProps {
  lang: 'uk' | 'ru';
}

const content = {
  uk: {
    name: 'Ірина Сергеєнко',
    desc: 'Професійна психологічна допомога для знаходження внутрішньої гармонії та впевненості. Марбелья, Іспанія.',
    nav: 'Навігація',
    services: 'Послуги',
    about: 'Про мене',
    testimonials: 'Відгуки',
    contact: 'Контакти',
    copy: '© 2025 Ірина Сергеєнко. Всі права захищені',
  },
  ru: {
    name: 'Ирина Сергеенко',
    desc: 'Профессиональная психологическая помощь для обретения внутренней гармонии и уверенности. Марбелья, Испания.',
    nav: 'Навигация',
    services: 'Услуги',
    about: 'Обо мне',
    testimonials: 'Отзывы',
    contact: 'Контакты',
    copy: '© 2025 Ирина Сергеенко. Все права защищены',
  },
};

export default function Footer({ lang }: FooterProps) {
  const t = content[lang];
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    setIsDark(document.documentElement.classList.contains('dark'));
  }, []);

  const toggleTheme = () => {
    const html = document.documentElement;
    if (html.classList.contains('dark')) {
      html.classList.remove('dark');
      localStorage.setItem('theme', 'light');
      setIsDark(false);
    } else {
      html.classList.add('dark');
      localStorage.setItem('theme', 'dark');
      setIsDark(true);
    }
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#F7F7F7] dark:bg-[#1A1A1A] pt-12 md:pt-16 pb-6">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid sm:grid-cols-2 gap-8 md:gap-12 mb-8 md:mb-10">
          <div>
            <div className="text-xl font-semibold text-[#333333] dark:text-[#EEEEEE] mb-3 md:mb-4">{t.name}</div>
            <p className="text-sm text-[#666666] dark:text-[#888888] leading-relaxed">{t.desc}</p>
          </div>

          <div>
            <h3 className="text-[15px] md:text-[16px] font-semibold text-[#333333] dark:text-[#EEEEEE] mb-4 md:mb-5">{t.nav}</h3>
            <div className="grid grid-cols-2 sm:grid-cols-1 gap-y-3 gap-x-4">
              <button onClick={() => scrollToSection('services')} className="text-left text-sm text-[#666666] dark:text-[#888888] hover:text-[#7EC8E3] dark:hover:text-[#7EC8E3] transition-colors cursor-pointer whitespace-nowrap">{t.services}</button>
              <button onClick={() => scrollToSection('about')} className="text-left text-sm text-[#666666] dark:text-[#888888] hover:text-[#7EC8E3] dark:hover:text-[#7EC8E3] transition-colors cursor-pointer whitespace-nowrap">{t.about}</button>
              <button onClick={() => scrollToSection('testimonials')} className="text-left text-sm text-[#666666] dark:text-[#888888] hover:text-[#7EC8E3] dark:hover:text-[#7EC8E3] transition-colors cursor-pointer whitespace-nowrap">{t.testimonials}</button>
              <button onClick={() => scrollToSection('contact')} className="text-left text-sm text-[#666666] dark:text-[#888888] hover:text-[#7EC8E3] dark:hover:text-[#7EC8E3] transition-colors cursor-pointer whitespace-nowrap">{t.contact}</button>
            </div>
          </div>
        </div>

        <div className="border-t border-[#E5E5E5] dark:border-[#2A2A2A] pt-5 md:pt-6 flex items-center justify-between gap-4">
          <p className="text-[12px] md:text-[13px] text-[#999999] dark:text-[#555555]">{t.copy}</p>

          <button
            onClick={toggleTheme}
            title={isDark ? 'Светлая тема' : 'Тёмная тема'}
            className="w-8 h-8 flex items-center justify-center rounded-full text-[#AAAAAA] dark:text-[#666666] hover:text-[#7EC8E3] dark:hover:text-[#7EC8E3] transition-colors cursor-pointer"
          >
            {isDark ? (
              <i className="ri-sun-line text-[18px]"></i>
            ) : (
              <i className="ri-moon-line text-[18px]"></i>
            )}
          </button>
        </div>
      </div>
    </footer>
  );
}
